import React, { useState } from "react";
import "./EditUserModal.css";

interface EditUserModalProps {
  user: any;
  onClose: () => void;
  onUpdate: (updatedUser: any) => void;
}

const EditUserModal: React.FC<EditUserModalProps> = ({
  user,
  onClose,
  onUpdate,
}) => {
  const [formData, setFormData] = useState({
    firstName: user.firstName || "",
    lastName: user.lastName || "",
    email: user.email || "",
    mobile: user.mobile || "",
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    onUpdate(formData);
    onClose();
  };

  return (
    <div className="edit-user-backdrop">
      <div className="edit-user-modal">
        <h2>Edit User</h2>

        <div className="edit-user-form-body">
          <div className="edit-user-form-row">
            <div className="edit-user-form-group">
              <label>
                First Name <span>*</span>
              </label>
              <input
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
              />
            </div>

            <div className="edit-user-form-group">
              <label>
                Last Name <span>*</span>
              </label>
              <input
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="edit-user-form-group">
            <label>
              Email Address <span>*</span>
            </label>
            <input
              name="email"
              value={formData.email}
              onChange={handleChange}
            />
          </div>

          <div className="edit-user-form-group">
            <label>
              Mobile Number <span>*</span>
            </label>
            <input
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="edit-user-modal-actions">
          <button className="edit-user-btn-cancel" onClick={onClose}>
            Cancel
          </button>
          <button className="edit-user-btn-update" onClick={handleSubmit}>
            Update
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditUserModal;
